import { AddCircleRounded, RemoveCircleRounded } from '@mui/icons-material';
import { styled, useTheme } from '@mui/material';
import React from 'react';
import { TreeItem } from '.';

const Container = styled('div')({
    height: 16,
    width: 16,
    fontSize: 13,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative'
});

interface NodeToggleCrossProps {
    firstChild?: boolean;
    lastChild?: boolean;
    onlyColumn?: boolean;
}

export function NodeToggleCross({ firstChild, lastChild, onlyColumn }: NodeToggleCrossProps) {
    return (
        <div style={{
            height: onlyColumn ? undefined : 20,
            width: 16,
            display: 'flex',
            flexDirection: 'row'
        }}>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}></div>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                <div
                    style={{
                        flex: 1,
                        borderLeft: firstChild ? undefined : '1px solid lightgray',
                        borderBottom: onlyColumn ? undefined : '1px solid lightgray'
                    }}
                />
                <div
                    style={{
                        flex: 1,
                        borderLeft: lastChild ? undefined : '1px solid lightgray'
                    }}
                />
            </div>
        </div>
    );
}

interface NodeToggleProps {
    item: TreeItem;
    onToggle: (item: TreeItem) => any;
    firstChild?: boolean;
    lastChild?: boolean;
}

const NodeToggle: React.FC<NodeToggleProps> = ({ item, onToggle, firstChild, lastChild }) => {
    const cbxTheme = useTheme();
    const style: React.CSSProperties = {
        color: cbxTheme.palette.mode === 'dark' ? '#f6f6f6' : 'rgb(21, 39, 47)',
        zIndex: 2
    };
    const content = !!item.toggled ? <RemoveCircleRounded style={style} fontSize='inherit' /> : <AddCircleRounded style={style} fontSize='inherit' />;
    return (
        <Container onClick={() => onToggle(item)} >
            {content}
        </Container>
    );
};

export default NodeToggle;